import React from "react";
import {
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";

const CurrencyList = ({ currencies, handleChange, value }) => {
  return (
    <Grid container item md={5} xs={5}>
      <TextField
        select
        label="Monedha"
        value={JSON.stringify(value) || ""}
        onChange={handleChange}
        color="warning"
        size="small"
        fullWidth={true}
      >
        {currencies &&
          currencies.map((option) => (
            <MenuItem
              key={option.blihet}
              value={JSON.stringify({
                name: option.monedha,
                buysFor: option.blihet,
                sellsFor: option.shitet
              })}
            >
              <Grid
                container
                item
                md={12}
                xs={12}
                justifyContent={"space-around"}
              >
                <Typography>{option.monedha}</Typography>
                <img src={option.imageUrl} alt="flag" width={"25px"} />
              </Grid>
            </MenuItem>
          ))}
      </TextField>
    </Grid>
  );
};

export default CurrencyList;
